





import { Component, Vue, Prop, Provide } from 'nuxt-property-decorator';

@Component
export default class DynamicContainerProvider extends Vue {
  @Prop({ type: Boolean, default: true })
  @Provide()
  skipContainer!: boolean
}
